var styles = {"radio":"styles_radio__oJWHx","icon":"styles_icon__oyHgc","input":"styles_input__D4TUY","active":"styles_active__PznmR","disabled":"styles_disabled__K3-SY","noSpacing":"styles_no-spacing__Uc6Ig","compactSpacing":"styles_compact-spacing__8SXJm","comfortableSpacing":"styles_comfortable-spacing__-j05Y","looseSpacing":"styles_loose-spacing__iUeFN","readOnly":"styles_read-only__XZcSc"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
